import React, { useState } from "react";

export default function WeatherTemperature(props) {
    const [unit, setUnit] = useState("celcius");

    function displayFahrenheit(event) {
        event.preventDefault();
        setUnit("fahrenheit");
    }

    function displayCelcius(event) {
        event.preventDefault();
        setUnit("celcius");
    }
    
    if (unit ==="celcius") {
    return (
        <div className="WeatherTemperature">
            <span className="temperature">{Math.round(props.celcius)}</span>
            <span className="unit">°C |{" "}
            <a href="/" onClick={displayFahrenheit}>°F</a> </span>
        </div>
    )
    }
    else {
    let fahrenheit = (props.celcius * 9) / 5 + 32;
    return (
        <div className="WeatherTemperature">
            <span className="temperature">{Math.round(fahrenheit)}</span>
            <span className="unit"><a href="/" onClick={displayCelcius}>°C</a> | {" "}°F</span>
        </div>
    )
    }
}